export default {
  'unknownError.title':
    'Whoops! Something went wrong on <color>Examod</color>.',
  'unknownError.desc':
    "There's an unexpected error while processing your request. We will fix the problem as soon as possible.",
  'unknownError.toHome': 'Return to Dashboard',
};
